import { CONTROL } from './Constants'

export interface Feature {
  control: string
  id: string
  [key: string]: any
}

export const title: Feature = {
  id: 'title',
  label: 'toolBuilder.features.title',
  control: CONTROL.TEXTFIELD_WITH_PERMALINK,
  notes: 'toolBuilder.features.title.notes',
  permaLinkProps: {
    id: 'permaLink',
    label: 'toolBuilder.features.permalink',
    notes: 'toolBuilder.features.permalink.notes',
    maxLength: 50,
  },
}
export const description: Feature = {
  id: 'description',
  label: 'toolBuilder.features.description',
  control: CONTROL.TEXTAREA,
  notes: 'toolBuilder.features.description.notes',
  maxLength: 400,
  allowRichText: true,
}

export const tags: Feature = {
  id: 'tags',
  label: 'toolBuilder.features.tags',
  control: CONTROL.TEXT,
  notes: 'toolBuilder.features.tags.notes',
  maxLength: 50,
  allowMultiple: true,
}

export const archivalMessage: Feature = {
  id: 'archivalMessage',
  label: 'toolBuilder.features.archivalMessage',
  control: CONTROL.TEXT,
  notes: 'toolBuilder.features.archivalMessage.notes',
}

export const permaLink: Feature = {
  id: 'permaLink',
  label: 'toolBuilder.features.permalink',
  control: CONTROL.PERMALINK,
  notes: 'toolBuilder.features.permalink.notes',
  maxLength: 50,
}

export const unverifiedParticipation: Feature = {
  id: 'allowUnverifiedParticipation',
  label: 'toolBuilder.features.unverifiedParticipation',
  control: CONTROL.SWITCH,
  notes: 'toolBuilder.features.unverifiedParticipation.notes',
}
export const comments: Feature = {
  id: 'allowComments',
  label: 'toolBuilder.features.comments',
  control: CONTROL.SWITCH,
  notes: 'toolBuilder.features.comments.notes',
  // maxLength: 400,
  // replies: {
  //   label: 'toolBuilder.features.comments.replies',
  //   control: CONTROL.SWITCH,
  //   notes: 'toolBuilder.features.comments.replies.notes',
  // },
  // reactions: {
  //   label: 'toolBuilder.features.comments.reactions',
  //   control: CONTROL.CHECKBOX_GROUP,
  //   notes: 'toolBuilder.features.comments.reactions.notes',
  //   options: ['like', 'dislike'],
  // },
}

export const imageUpload: Feature = {
  id: 'allowImageUpload',
  label: 'toolBuilder.features.imageUpload',
  control: CONTROL.SWITCH,
  notes: 'toolBuilder.features.imageUpload.notes',
}

export const reaction: Feature = {
  id: 'allowReactions',
  label: 'toolBuilder.features.reaction.title',
  control: CONTROL.GROUP,
  notes: 'toolBuilder.features.reaction.notes',
  indent: true,
  limitVoting: {
    id: 'limitVoting',
    label: 'toolBuilder.features.reaction.limitVoting.title',
    control: CONTROL.GROUP,
    limitVotingCount: {
      id: 'limitVotingCount',
      label: 'toolBuilder.features.reaction.limitVoting.count',
      control: CONTROL.NUMBER,
    },
  },
  schedule: {
    id: 'allowScheduleReactions',
    label: 'toolBuilder.features.reaction.scheduled.title',
    control: CONTROL.GROUP,
    notes: 'toolBuilder.features.reaction.scheduled.notes',
    scheduleReaction: {
      id: 'scheduledReactionsDateRange',
      label: 'toolBuilder.features.reaction.scheduled.title',
      control: CONTROL.DATE_RANGE,
      notes: 'toolBuilder.features.reaction.scheduled.dateRange.notes',
      start: 'toolBuilder.features.reaction.scheduled.dateRange.start',
      end: 'toolBuilder.features.reaction.scheduled.dateRange.end',
    },
  },

  // reactions: {
  //   label: 'toolBuilder.features.reaction.reactions',
  //   control: CONTROL.CHECKBOX_GROUP,
  //   notes: 'toolBuilder.features.reaction.reactions.notes',
  //   options: [
  //     {
  //       label: 'toolBuilder.features.reaction.reactions.thumbsUp',
  //       control: CONTROL.ICON,
  //       icon: 'thumbs-up',
  //     },
  //     {
  //       label: 'toolBuilder.features.reaction.reactions.thumbsDown',
  //       control: CONTROL.ICON,
  //       icon: 'thumbs-down',
  //     },
  //   ],
  // },
}

export const notification: Feature = {
  id: 'allowNotification',
  label: 'toolBuilder.features.notification.title',
  control: CONTROL.CHECKBOX_GROUP,
  notes: 'toolBuilder.features.notification.notes',
  options: [
    {
      id: 'notifyParticipant',
      label: 'toolBuilder.features.notification.notifyParticipant',
    },
    {
      id: 'notifyAdmins',
      label: 'toolBuilder.features.notification.notifyAdmins',
      autoComplete: {
        id: 'adminEmails',
        label: 'toolBuilder.features.notification.emails',
        autoFocus: true,
        control: CONTROL.ADMIN_EMAILS,
        notes:
          'toolBuilder.features.notification.addRecepients.recepient.notes',
      },
    },
  ],
}

export const share: Feature = {
  id: 'allowShare',
  label: 'toolBuilder.features.share',
  control: CONTROL.CHECKBOX_GROUP,
  notes: 'toolBuilder.features.share.notes',
  options: [
    {
      label: 'toolBuilder.features.share.facebook',
      control: CONTROL.ICON,
      icon: 'facebook',
    },
    {
      label: 'toolBuilder.features.share.x',
      control: CONTROL.ICON,
      icon: 'x',
    },
    {
      label: 'toolBuilder.features.share.linkedin',
      control: CONTROL.ICON,
      icon: 'linkedin',
    },
  ],
}
